function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import clone from "lodash/cloneDeep";
import get from "lodash/get";
import isEqual from "lodash/isEqual";
import set from "lodash/set";
import toPath from "lodash/toPath";
import { hasErrorDep, submittingDep, dirtyDep } from "../dependencySymbols/dependencySymbols";
export function SilkyEngine() {
    var initialMountValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var checkHasError = function checkHasError() {
        return Object.values(errors).length > 0;
    };
    var getSafeFieldCallback = function getSafeFieldCallback(key) {
        var callback = getFieldCallback(key);
        if (typeof callback === 'function') {
            return callback;
        }
        return function() {};
    };
    var setValue = function setValue(key, newValue) {
        set(values, key, newValue);
        var safeFieldCallback = getSafeFieldCallback(key);
        if (safeFieldCallback) {
            safeFieldCallback('value', key, newValue);
        }
        setDirty(determineDirty());
        runValidation(key);
        var keyAsPath = toPath(key);
        if (keyAsPath.length > 1) {
            var rootFieldCallback = getSafeFieldCallback(keyAsPath[0]);
            if (rootFieldCallback) {
                rootFieldCallback('value', keyAsPath[0], getValue(keyAsPath[0]));
            }
        }
        getDependents(key).forEach(function(dependent) {
            var dependentFieldCallback = getSafeFieldCallback(dependent);
            if (dependentFieldCallback) {
                dependentFieldCallback('value', dependent, newValue);
            }
            runValidation(dependent);
        });
    };
    var initialValues = _objectSpread({}, initialMountValues);
    var getInitialValues = function() {
        return clone(_objectSpread({}, initialValues));
    };
    var setInitialValues = function() {
        var newValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return initialValues = clone(_objectSpread({}, newValues));
    };
    var values = getInitialValues();
    var getValue = function(key) {
        return clone(get(values, key));
    };
    var removeValue = function(key) {
        var result = delete values[key];
        setDirty(determineDirty());
        return result;
    };
    var getAllValues = function() {
        var allValues = _objectSpread({}, values);
        Object.getOwnPropertySymbols(allValues).forEach(function(symbol) {
            return delete allValues[symbol];
        });
        return Object.freeze(allValues);
    };
    var resetValues = function() {
        Object.keys(_objectSpread({}, getInitialValues(), getAllValues())).forEach(function(key) {
            if ((typeof key === "undefined" ? "undefined" : _typeof(key)) !== 'symbol' && !isEqual(initialValues[key], values[key])) {
                setValue(key, clone(initialValues[key]));
            }
        });
    };
    var validators = {};
    var getValidator = function(key) {
        return validators[key];
    };
    var setValidator = function(key, validator, dependencies) {
        return validators[key] = [
            validator,
            dependencies
        ];
    };
    var removeValidator = function(key) {
        return delete validators[key];
    };
    var getAllValidators = function() {
        return Object.freeze(_objectSpread({}, validators));
    };
    var hasError = false;
    var getHasError = function() {
        return !!hasError;
    };
    var setHasError = function(bool) {
        hasError = !!bool;
        setValue(hasErrorDep, !!bool);
    };
    var errors = {};
    var getError = function(key) {
        return errors[key];
    };
    var setError = function(key, errorArray) {
        errors[key] = errorArray;
        var safeFieldCallback = getSafeFieldCallback(key);
        if (safeFieldCallback) {
            safeFieldCallback('error', key, errorArray);
        }
        var nextHasError = checkHasError();
        if (nextHasError) {
            setHasError(true);
        }
    };
    var removeError = function(key) {
        delete errors[key];
        var safeFieldCallback = getSafeFieldCallback(key);
        if (safeFieldCallback) {
            safeFieldCallback('error', key, undefined);
        }
        setHasError(checkHasError());
    };
    var getAllErrors = function() {
        return Object.freeze(_objectSpread({}, errors));
    };
    var resetErrors = function() {
        var allErrors = getAllErrors();
        Object.keys(allErrors).forEach(function(key) {
            return allErrors[key] !== undefined && removeError(key);
        });
        errors = {};
    };
    var fieldCallbacks = {};
    var getFieldCallback = function(key) {
        return fieldCallbacks[key];
    };
    var removeFieldCallback = function(key) {
        delete fieldCallbacks[key];
    };
    var dependents = {};
    var getDependents = function(fieldName) {
        var deps = dependents[fieldName];
        return Array.isArray(deps) ? _toConsumableArray(deps) : [];
    };
    var addDependent = function(fieldName, dependentFieldName) {
        var fieldDeps = dependents[fieldName];
        if (Array.isArray(fieldDeps)) {
            if (!fieldDeps.includes(dependentFieldName)) {
                dependents[fieldName] = _toConsumableArray(fieldDeps).concat([
                    dependentFieldName
                ]);
            }
        } else {
            dependents[fieldName] = [
                dependentFieldName
            ];
        }
    };
    var removeDependent = function(fieldName, dependentFieldName) {
        var fieldDeps = dependents[fieldName];
        if (Array.isArray(fieldDeps)) {
            if (fieldDeps.includes(dependentFieldName)) {
                dependents[fieldName] = fieldDeps.filter(function(dependent) {
                    return dependent !== dependentFieldName;
                });
            }
        } else {
            dependents[fieldName] = [];
        }
    };
    var subscribe = function(fieldName, setFieldState, dependencies) {
        fieldCallbacks[fieldName] = setFieldState;
        if (Array.isArray(dependencies)) {
            dependencies.forEach(function(key) {
                return addDependent(key, fieldName);
            });
        }
    };
    var unsubscribe = function(fieldName, dependencies) {
        removeFieldCallback(fieldName);
        if (Array.isArray(dependencies)) {
            dependencies.forEach(function(key) {
                return removeDependent(key, fieldName);
            });
        }
    };
    var runValidation = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(key) {
            var value, ref, ref1, validator, dependencies, dependencyValues, error, formattedError;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        value = getValue(key);
                        ;
                        ref1 = _slicedToArray((ref = getValidator(key)) !== null && ref !== void 0 ? ref : [], 2), validator = ref1[0], dependencies = ref1[1];
                        dependencyValues = Array.isArray(dependencies) ? dependencies.reduce(function(accumulator, dependencyKey) {
                            return _objectSpread({}, accumulator, _defineProperty({}, dependencyKey, getValue(dependencyKey)));
                        }, {}) : undefined;
                        ;
                        if (!(typeof validator === 'function')) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.prev = 6;
                        _ctx.next = 9;
                        return validator(value, dependencyValues);
                    case 9:
                        error = _ctx.sent;
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](6);
                        throw Error("UNCAUGHT VALIDATION ERROR in field named \"".concat(key, "\""), _ctx.t0);
                    case 15:
                        formattedError = Array.isArray(error) || typeof error === 'undefined' ? error : [
                            error
                        ];
                        if (!(getError(key) === undefined && error === undefined) && !isEqual(formattedError, getError(key))) {
                            if (error === undefined) {
                                removeError(key);
                            } else {
                                setError(key, formattedError);
                            }
                        }
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    12
                ]
            ]);
        }));
        return function runValidation(key) {
            return _ref.apply(this, arguments);
        };
    }();
    var runAllValidations = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return Promise.all(Object.keys(getAllValidators()).map(function(fieldName) {
                            return runValidation(fieldName);
                        }));
                    case 2:
                        return _ctx.abrupt("return", getAllErrors());
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function runAllValidations() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitting = false;
    var getSubmitting = function() {
        return submitting;
    };
    var setSubmitting = function(bool) {
        submitting = !!bool;
        setValue(submittingDep, !!bool);
    };
    var dirty = false;
    var getDirty = function() {
        return !!dirty;
    };
    var setDirty = function(bool) {
        var lastDirty = !!dirty;
        dirty = !!bool;
        if (lastDirty !== dirty) {
            setValue(dirtyDep, !!bool);
        }
    };
    var determineDirty = function() {
        return !isEqual(getInitialValues(), getAllValues());
    };
    var removeData = function(fieldName) {
        removeValue(fieldName);
        removeValidator(fieldName);
        removeError(fieldName);
    };
    return {
        getInitialValues: getInitialValues,
        setInitialValues: setInitialValues,
        getValue: getValue,
        setValue: setValue,
        removeValue: removeValue,
        getAllValues: getAllValues,
        resetValues: resetValues,
        getError: getError,
        setError: setError,
        removeError: removeError,
        getAllErrors: getAllErrors,
        resetErrors: resetErrors,
        getValidator: getValidator,
        setValidator: setValidator,
        removeValidator: removeValidator,
        getAllValidators: getAllValidators,
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        runValidation: runValidation,
        runAllValidations: runAllValidations,
        getSubmitting: getSubmitting,
        setSubmitting: setSubmitting,
        getDirty: getDirty,
        setDirty: setDirty,
        determineDirty: determineDirty,
        getHasError: getHasError,
        removeData: removeData
    };
}
export default SilkyEngine;
